import { cva } from "class-variance-authority";
/**
 * Success banner container styles
 */
export const successBannerVariants = cva("flex items-center gap-3 w-full", {
    variants: {},
    defaultVariants: {},
});
//# sourceMappingURL=success-banner.styles.js.map